/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Kontakte_Knupfen19Inputs */

const en__field_enum_tuda_kontakte_knupfen19 = /** @type {(inputs: _Field_Enum_Tuda_Kontakte_Knupfen19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other People`)
};

const de__field_enum_tuda_kontakte_knupfen19 = /** @type {(inputs: _Field_Enum_Tuda_Kontakte_Knupfen19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakte knüpfen`)
};

/**
* | output |
* | --- |
* | "Get to know other People" |
*
* @param {_Field_Enum_Tuda_Kontakte_Knupfen19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_kontakte_knupfen19 = /** @type {((inputs?: _Field_Enum_Tuda_Kontakte_Knupfen19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Kontakte_Knupfen19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_kontakte_knupfen19(inputs)
	return de__field_enum_tuda_kontakte_knupfen19(inputs)
});
export { _field_enum_tuda_kontakte_knupfen19 as "_field_enum_TUDA_KONTAKTE_KNUPFEN" }